import * as model from './model.js';
import recipeView from './view/recipeView.js';
import searchResults from './view/searchResults.js';
import searchView from './view/searchView.js';
import paginationView from './view/pagination.js';
import bookmarksView from './view/bookmarks.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { async } from 'regenerator-runtime';

if (module.hot) {
  module.hot.accept();
}

// https://forkify-api.herokuapp.com/v2

// renderSpinner(recipeContainer);
////////////////////////////////////////////Fetching and rendering data//////////////////////////
const controlRecipe = async function () {
  try {
    recipeView.renderMessage();
    ////////////////////////reciving id ////////////////////////
    let id = window.location.hash.slice(1);
    // console.log(id);
    if (!id) return recipeView.renderMessage();
    // update results view to marked selected recipe
    searchResults.update(model.getSearchResultsPage());
    bookmarksView.update(model.state.bookmarks);
    recipeView.renderSpinner();
    ////passing id in loadRecipe funtion as argument and loadrecipe is an async funtion so we will await it because it going return promise
    await model.loadRecipe(id);
    const recipe = model.state.recipe;
    if (!recipe) return '';
    //render method to pass on data to recipeview.js
    recipeView.render(recipe);
    if (model.state.bookmarks.length === 0) return bookmarksView.renderError();
    id = '';
  } catch (err) {
    console.error(err);
    //sending error message to the ui
    recipeView.renderError();
  }
};

const controlSearchResults = async function () {
  searchResults.renderSpinner();
  model.state.search.page = 1;
  // recive search querry
  const query = searchView.getQuery();
  if (!query) return searchResults.renderError();
  // fetching api
  await model.loadSearchResults(query);
  // storing the response
  const results = model.getSearchResultsPage();
  // console.log(results);
  // send data to the view
  if (!results || results.length === 0) return searchResults.renderError();
  searchResults.render(results);
  //updating bookmarks view after adding or deleting a bookmark
  /////sending state.search data to pagination.view
  paginationView.render(model.state.search);
};

const controlPagination = function (gotoPage) {
  searchResults.render(model.getSearchResultsPage(gotoPage));
  paginationView.render(model.state.search);
};

const controlServings = function (newServings) {
  model.updateServings(newServings);
  recipeView.update(model.state.recipe);
};

const controlBookmark = function () {
  if (!model.state.recipe.bookmarked) model.addBookMark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);
  recipeView.update(model.state.recipe);
  bookmarksView.render(model.state.bookmarks);
  if (model.state.bookmarks.length === 0) return bookmarksView.renderError();
  // console.log(model.state.bookmarks);
  // console.log(model.state.recipe.bookmarked);
};

const loadBookmarks = function () {
  bookmarksView.render(model.state.bookmarks);
};

const init = function () {
  bookmarksView.addHandlerRender(loadBookmarks);
  recipeView.addHandlerRender(controlRecipe);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerBookmark(controlBookmark);
};
init();
